<script lang="ts">
  import EditableText from './EditableText.svelte';
  import Provenance from './Provenance.svelte';
  import type { BlockTiles, RenderCtx } from './types';

  let { block, ctx, editing = false, onchange }: {
    block: BlockTiles;
    ctx: RenderCtx;
    editing?: boolean;
    onchange?: (next: BlockTiles) => void;
  } = $props();

  function editFact(tile: number, fact: number, text: string) {
    onchange?.({
      ...block,
      items: block.items.map((t, i) => i === tile
        ? { ...t, facts: t.facts.map((f, j) => (j === fact ? { ...f, text } : f)) }
        : t),
    });
  }
  function editAngle(tile: number, text: string) {
    onchange?.({
      ...block,
      items: block.items.map((t, i) => (i === tile ? { ...t, angle: { ...t.angle, text } } : t)),
    });
  }
</script>

<div class="brf-tiles">
  {#each block.items as tile, t (t)}
    {@const portfolioId = ctx.portfolioCompanyId?.(tile.name)}
    <article class="brf-tile">
      <h4>{#if portfolioId && ctx.onOpenPortfolioCompany && !editing}<button type="button"
          class="brf-entity-link" title="Open {tile.name} in Portfolio"
          onclick={() => ctx.onOpenPortfolioCompany?.(portfolioId)}>{tile.name}</button>{:else}{tile.name}{/if}</h4>
      <p class="brf-tile-m"><span class="why">{tile.why}</span>{#if tile.meta}{' '}· {tile.meta}{/if}</p>
      <ul>
        {#each tile.facts as fact, f (f)}
          <li><EditableText value={fact.text} {editing} ariaLabel="{tile.name}, fact {f + 1}"
                onchange={(text) => editFact(t, f, text)} /><Provenance
                provenance={fact.provenance} sourceIds={fact.source_ids} {ctx} /></li>
        {/each}
      </ul>
      <p class="brf-tile-a">&ldquo;<EditableText value={tile.angle.text} {editing}
          ariaLabel="{tile.name}, what to say"
          onchange={(text) => editAngle(t, text)} />&rdquo;</p>
    </article>
  {/each}
</div>
